// interface.
import { IRoute } from '@routes/routes';

// types.
import {
  documentAuditPath,
  documentsVisualizer,
  documentTask,
  reassignTasks,
  georeferencing,
} from './routes.types';

// components.
import { DocumentAuditsDashboard } from '../modules/DocumentsAuditDashboard/DocumentsAuditDashboard';
import { DocumentTaskDetail } from '../modules/DocumentTaskDetail/DocumentTaskDetail';
import { DocumentsVisualizer } from '../modules/DocumentsVisualizer/DocumentsVisualizer';
import { ReassignDocumentsTable } from '../modules/ReassignDocumentsTask/ReassignDocumentsTask';
import { Georeferencing } from '../modules/Georeferencing/Georeferencing';

export const routesDocumentAuditPage: IRoute[] = [
  {
    id: 'document-audit-dashboard',
    path: `${documentAuditPath}`,
    element: <DocumentAuditsDashboard />,
  },
  {
    id: 'document-task-detail',
    path: `${documentTask}`,
    element: <DocumentTaskDetail />,
  },
  {
    id: 'document-visualizer',
    path: `${documentsVisualizer}`,
    element: <DocumentsVisualizer />,
  },
  {
    id: 'reassign-tasks',
    path: `${reassignTasks}`,
    element: <ReassignDocumentsTable />,
  },
  {
    id: 'georeferencing',
    path: `${georeferencing}`,
    element: <Georeferencing />,
  },
];
